// src/components/PlaybackButton.js
import React from 'react';
import IconButton from '@mui/material/IconButton';
import { Play} from 'lucide-react';

import { useMessageHandler } from '../contexts/MessageContext';

const PlaybackButton = ({ onPlayClick, disabled }) => {
    const { isPlaybackActive } = useMessageHandler();
    
    const handleClick = () => {
      if (!disabled && !isPlaybackActive) {
        onPlayClick();
      }
    };
  
    return (
      <IconButton
        size="small"
        onClick={handleClick}
        disabled={disabled || isPlaybackActive}
      >
        <Play size={16} />
      </IconButton>
    );
  };

export default PlaybackButton;